module.exports = __webpack_public_path__ + "img/1.9a1642b9.png";